const style = `
 .amount.route-container {
   background: #777777;
   margin-top:0px!important;
 }
 .no-select.notranslate {
    padding: 5px 30px!important;
    border-radius: 15px!important;
 }
 .ion.hydrated {
   color: white!important;
 }
 .receipt {
   background: ##5a5a5a!important;
 }
`

export default style
